import React, { useEffect } from "react";
import { WEBAPP_URL } from "../siteConfig";
import { useDocumentMeta } from "../useDocumentMeta";
import "../styles/redirect.css";

/** Build the web-app registration URL, carrying through plan/seats params. */
const buildTarget = () => {
  const params = new URLSearchParams(window.location.search);
  const plan = params.get("plan") || "free";
  const seats = params.get("seats");

  // The web app signs you up on first sign-in; it has no /register route.
  const target = new URL(WEBAPP_URL);
  target.searchParams.set("plan", plan);
  target.searchParams.set("src", "website");
  if (seats) target.searchParams.set("seats", seats);
  return target.toString();
};

const RegistrationPage = () => {
  useDocumentMeta({
    title: "Create your PABS account",
    description:
      "Redirecting you to the PABS web app to create your account and start ordering food, groceries, Pasugo errands, and rides.",
    canonicalPath: "/registration",
  });

  useEffect(() => {
    // Always send the user to the registration page in the web-app.
    window.location.replace(buildTarget());
  }, []);

  return (
    <main className="rdx" id="main">
      <div className="rdx__card">
        <img
          className="rdx__mark"
          src="/pabs-mark.png"
          alt="PABS"
          width={64}
          height={64}
        />
        <div className="rdx__spinner" aria-hidden="true" />
        <h1 className="t-h3">Taking you to sign up…</h1>
        <p className="t-sm">
          We're opening the PABS web app so you can create your account.
        </p>

        <div className="rdx__actions">
          <a className="btn btn--primary" href={buildTarget()}>
            Continue to sign up
          </a>
          <a className="btn btn--ghost btn--sm" href="/">
            Back to homepage
          </a>
        </div>
      </div>
    </main>
  );
};

export default RegistrationPage;
